/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import FlatList from 'flatlist-react';
import { Row, Col, Nav } from 'react-bootstrap';
// import { AppCard, IAppCardList } from "@vlinder-web/app-card-widget-react";
import {
  AppCard,
  IAppCardList,
} from '../../../../widgets/app-card-widget-react';

import { useTheme } from '../../../../providers/theme';
import * as S from './styles';

export interface IAppCardListCompProps {
  appCardList?: IAppCardList[];
  onCardClick?(id?: string): void;
  appCardGridRow?: {
    xs: 1 | 2 | 3 | 4;
    md: 1 | 2 | 3 | 4;
    lg: 1 | 2 | 3 | 4;
  };
}

export const AppCardListComp = ({
  appCardList,
  gridRow,
  onCardClick,
}: IAppCardListCompProps) => {
  const theme = useTheme();
  const _renderItem = (appCard: any, index: number) => {
    return (
      <Col
        key={`app-card-col-${index}`}
        xs={gridRow?.xs ? 12 / gridRow?.xs : 12}
        md={gridRow?.md ? 12 / gridRow?.md : 6}
        lg={gridRow?.lg ? 12 / gridRow?.lg : 4}
        // lg={gridRow?.lg ? 12 / gridRow?.lg : 3}
        style={S.CardContainerStyle}
        onClick={() => onCardClick && onCardClick(appCard?.appCardId)}
      >
        <AppCard
          {...(appCard || { appCardId: index })}
          // hoverColor={theme?.colors?.secondary}
        />
      </Col>
    );
  };
  return (
    <>
      <Row>
        <FlatList
          list={appCardList}
          renderItem={_renderItem}
          renderWhenEmpty={() => <div>List is empty!</div>}
        />
      </Row>
    </>
  );
};

AppCardListComp.defaultProps = {
  appCardList: [],
};
